import React from 'react';
import { m } from 'framer-motion';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { stats } from '../../data/trustStats';
export function TrustStats() {
  return <section className="border-y border-primary/5 bg-paper py-8 sm:py-10" data-id="element-244" data-mp="37r20b5ieb6ub">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-245" data-mp="37t50ujh6cida">
        <ScrollHintTable minWidth="640px" data-id="element-246" data-mp="32r7cjatx2xdh">
          <div className="grid grid-cols-4 divide-x divide-primary/10 bg-white" data-id="element-247" data-mp="32ulckcf3yuhr">
            {stats.map((stat, i) => <m.div key={stat.label} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.06
          }} className="flex flex-col items-center gap-2 px-3 py-6 text-center" data-id="element-248" data-mp="2u06ygd6bdq08" data-mpi={i}>
                <stat.icon size={22} className="text-accent" data-id="element-249" data-mp="2f1v267musj9l" />
                <span className="font-heading text-xl font-bold text-primary sm:text-2xl" data-id="element-250" data-mp="2b0t4hv8l4f9q">{stat.value}</span>
                <span className="text-xs text-ink/70 sm:text-sm" data-id="element-251" data-mp="1928drktj4xqd">{stat.label}</span>
              </m.div>)}
          </div>
        </ScrollHintTable>
      </div>
    </section>;
}